
export const SAVE_I140FORMS_STARTED = "SAVE_I140FORMS_STARTED";
export const SAVE_I140FORMS_SUCCESS = "SAVE_I140FORMS_SUCCESS";
export const SAVE_I140FORMS_FAILED = "SAVE_I140FORMS_FAILED"; 

export const UPDATE_I140FORMS_STARTED = "UPDATE_I140FORMS_STARTED";
export const UPDATE_I140FORMS_SUCCESS = "UPDATE_I140FORMS_SUCCESS";
export const UPDATE_I140FORMS_FAILED = "UPDATE_I140FORMS_FAILED";

export const GET_I140FORMS_STARTED = "GET_I140FORMS_STARTED";
export const GET_I140FORMS_SUCCESS = "GET_I140FORMS_SUCCESS";
export const GET_I140FORMS_FAILED = "GET_I140FORMS_FAILED";

export const SAVEPDF_I140FORMS_STARTED = "SAVEPDF_I140FORMS_STARTED";
export const SAVEPDF_I140FORMS_SUCCESS = "SAVEPDF_I140FORMS_SUCCESS";
export const SAVEPDF_I140FORMS_FAILED = "SAVEPDF_I140FORMS_FAILED";



export const i140formsCreate = (i140formsCreateInput: any) => {
 
    return {
        type: SAVE_I140FORMS_STARTED,
        payload: 'status',
        input: i140formsCreateInput
    };
};

export const i140formsUpdate = (i140formsUpdateInput: any) => {

   return {
       type: UPDATE_I140FORMS_STARTED,
       payload: 'status',
       input: i140formsUpdateInput
   };

};
export const getI140formsDetails = (i140formsUpdateInput: any) => {
   
    return {
        type: GET_I140FORMS_STARTED ,
        payload: 'Value',
        input:i140formsUpdateInput
    };
};

export const i140FormPdfSubmit = (pdfInput) => {
 
    return {
        type: SAVEPDF_I140FORMS_STARTED,
        payload: 'Value',
        input:pdfInput
    };
};

// ETA-9089 (full form) upload -> JSON, caseflowinitiation/eta9089/extract/{fileUploadId}
export const EXTRACT_ETA9089_STARTED = "EXTRACT_ETA9089_STARTED";
export const EXTRACT_ETA9089_SUCCESS = "EXTRACT_ETA9089_SUCCESS";
export const EXTRACT_ETA9089_FAILED = "EXTRACT_ETA9089_FAILED";
export const EXTRACT_ETA9089_RESET = "EXTRACT_ETA9089_RESET";

export const eta9089Extract = (fileUploadId: any) => {

    return {
        type: EXTRACT_ETA9089_STARTED,
        payload: 'Value',
        input: fileUploadId
    };
};

export const resetEta9089Extract = () => {

    return {
        type: EXTRACT_ETA9089_RESET
    };
};

// stored ETA-9089 JSON of an upload, caseflowinitiation/eta9089/getByFileUploadId/{fileUploadId}
export const GET_ETA9089_STARTED = "GET_ETA9089_STARTED";
export const GET_ETA9089_SUCCESS = "GET_ETA9089_SUCCESS";
export const GET_ETA9089_FAILED = "GET_ETA9089_FAILED";

export const getEta9089Form = (fileUploadId: any) => {

    return {
        type: GET_ETA9089_STARTED,
        payload: 'Value',
        input: fileUploadId
    };
};

// edited ETA-9089 JSON over the stored one, caseflowinitiation/eta9089/update/{fileUploadId}
export const UPDATE_ETA9089_STARTED = "UPDATE_ETA9089_STARTED";
export const UPDATE_ETA9089_SUCCESS = "UPDATE_ETA9089_SUCCESS";
export const UPDATE_ETA9089_FAILED = "UPDATE_ETA9089_FAILED";

export const updateEta9089Form = (fileUploadId: any, eta9089Form: any) => {

    return {
        type: UPDATE_ETA9089_STARTED,
        payload: 'Value',
        input: fileUploadId,
        eta9089Form: eta9089Form
    };
};
